// @flow
import React from 'react'
import classnames from 'classnames'

import AbstractFormField from './AbstractFormField'

// core
import moment from '../../Moment'
import { checkDate, parseRelativeDatetime, renderDate } from '../../DateTimeFunctions'

// types
import type { DefaultFormFieldState, DefaultFormFieldType } from './AbstractFormField'

type DateTextProps = DefaultFormFieldType & {
  domain: {
    _type: string,
    pattern?: string,
    minDate?: string,
    maxDate?: string
  },
  value?: Date,
}

type DateTextState = DefaultFormFieldState & {
  editCompleted: boolean,
}


export default class DateText extends AbstractFormField<DateTextProps, DateTextState> {

  constructor(props: DateTextProps) {
    super(props)
    this.state = {
      editCompleted: true,
      pristine: true,
    }
  }

  componentDidMount() {
    if (this.props.value) {
      this.checkDate(this.props.value)
    }
  }

  changeRange = (props: DateTextProps, minDatePush: ?string, maxDatePush: ?string) => {
    let minDate = null
    let maxDate = null

    if (minDatePush || props.domain.minDate) {
      minDate = moment(minDatePush || props.domain.minDate)
    } else if (props.domain.minDateRelative || props.domain.minDateTimeRelative) {
      minDate = parseRelativeDatetime(props.domain.minDateRelative || props.domain.minDateTimeRelative)
    }
    if (maxDatePush || props.domain.maxDate) {
      maxDate = moment(maxDatePush || props.domain.maxDate)
    } else if (props.domain.maxDateRelative || props.domain.maxDateTimeRelative) {
      maxDate = parseRelativeDatetime(props.domain.maxDateRelative || props.domain.maxDateTimeRelative)
    }
    this.setState({ minDate, maxDate })
  }

  handleIsValidDate = (currentDate: Object) => {
    const minPassed = !this.state.minDate ? true : currentDate.diff(this.state.minDate) > 0
    const maxPassed = !this.state.maxDate ? true : this.state.maxDate.diff(currentDate) > 0
    return minPassed && maxPassed
  }

  checkDate = (date: string) => {
    let newState: Object = { pristine: false }
    const dateObject = moment(date, ['YYYY-MM-DD', 'DD.MM.YYYY'])
    if (!dateObject.isValid() && date !== '') {
      this.props.onChange('')
    } else {
      newState.value = dateObject
    }
    this.setState(newState)
  }

  handleOnChange = (event: SyntheticInputEvent<HTMLInputElement>) => {
    this.setState({ editCompleted: false })
    this.props.onChange(event.target.value)
  }

  handleOnBlur = (event: SyntheticInputEvent<HTMLInputElement>) => {
    this.setState({ editCompleted: true })
    const dateString = event.target.value
    if (dateString) {
      this.checkDate(dateString)
    }
  }

  checkDate = (dateString: string) => {
    /* const date = checkDate(dateString, this.props.minDate, this.props.maxDate)
    this.setState({ pristine: false })
    if (date.isValid()) {
      this.props.onChange(date.format('YYYY-MM-DD'))
    } else {
      this.props.onChange(moment().format('YYYY-MM-DD'))
    } */
  }

  render() {
    if (this.props.textMode) {
      return <span>{renderDate(this.props.value, this.state.editCompleted)}</span>
    }

    const classes = ['form-control']
    if (this.hasErrors() && !this.isPristine()) {
      classes.push('is-invalid')
    }

    return (
      <div>
        <input
          className={classnames(classes)}
          data-hj-whitelist
          id={this.props.id}
          name={this.props.name}
          onBlur={this.handleOnBlur}
          onChange={this.handleOnChange}
          placeholder=''
          readOnly={!this.props.enabled}
          type='text'
          value={renderDate(this.props.value, this.state.editCompleted)}
        />
        {this.renderError()}
      </div>
    )
  }
}
